(function(){
  var NAVY='#14213D',SILVER='#8FA3BF',LIGHT='#F4F6F9';
  var GOLD=['rgb(208, 169, 51)','rgb(251, 191, 36)','rgb(58, 50, 32)'];
  var DARK=['rgb(13, 13, 13)','rgb(17, 17, 17)','rgb(0, 0, 0)','rgb(26, 26, 26)'];
  var o,t;
  function imp(el,p,v){el.style.setProperty(p,v,'important');}
  function rgb(s){var m=s.match(/[\d.]+/g);return m?m.map(Number):[0,0,0,0];}
  function effBg(el){
    while(el&&el.nodeType===1){
      var c=rgb(getComputedStyle(el).backgroundColor);
      if(c.length<4||c[3]>0.5){return c;}
      el=el.parentElement;
    }
    return [20,33,61,1];
  }
  function fix(){
    var roots=document.querySelectorAll('.es-modal,.es-popup-button,.es-sticky-btn');
    var els=[];
    roots.forEach(function(r){els.push(r);r.querySelectorAll('*').forEach(function(e){els.push(e);});});
    els.forEach(function(e){
      if(e.matches('.es-loading-mask,.es-modal')||e.closest('.es-popup-button,.es-sticky-btn,.es-cta-btn,.es-button')){return;}
      var s=getComputedStyle(e);
      if(GOLD.indexOf(s.backgroundColor)>-1){imp(e,'background-color',SILVER);}
      else if(DARK.indexOf(s.backgroundColor)>-1){imp(e,'background-color',NAVY);}
      if(s.backgroundImage!=='none'&&e.matches('.es-popup-button,.es-sticky-btn,.es-cta-btn,.es-button')){imp(e,'background-image','none');imp(e,'background-color',SILVER);}
      ['Top','Right','Bottom','Left'].forEach(function(d){
        var c=s['border'+d+'Color'];
        if(GOLD.indexOf(c)>-1){imp(e,'border-'+d.toLowerCase()+'-color',SILVER);}
      });
    });
    els.forEach(function(e){
      if(e.matches('input,select,textarea,.es-loading-mask,.es-modal')||e.closest('.es-popup-button,.es-sticky-btn,.es-cta-btn,.es-button')){return;}
      var bg=effBg(e);
      var avg=(bg[0]+bg[1]+bg[2])/3;
      imp(e,'color',avg>110?NAVY:LIGHT);
    });
    document.querySelectorAll('.es-popup-button,.es-sticky-btn').forEach(function(b){b.style.removeProperty('box-shadow');});
  }
  function run(){
    if(o){o.disconnect();}
    fix();
    if(o){o.observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['style','class']});}
  }
  function schedule(){
    clearTimeout(t);
    t=setTimeout(run,60);
  }
  o=new MutationObserver(schedule);
  run();
  document.addEventListener('DOMContentLoaded',run);
})();
